var _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(8 0)",
    cx: 0,
    cy: 16,
    r: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0; 4; 0; 0",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0,
    keyTimes: "0;0.2;0.7;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(16 0)",
    cx: 0,
    cy: 16,
    r: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0; 4; 0; 0",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.3,
    keyTimes: "0;0.2;0.7;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    transform: "translate(24 0)",
    cx: 0,
    cy: 16,
    r: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0; 4; 0; 0",
    dur: "1.2s",
    repeatCount: "indefinite",
    begin: 0.6,
    keyTimes: "0;0.2;0.7;1",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8",
    calcMode: "spline"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBubbles);
export default __webpack_public_path__ + "static/media/icon-bubbles.d0251100e46b1bc807e70c5c0ea1022a.svg";
export { ForwardRef as ReactComponent };